import {
    // messages
    REQUEST_MESSAGES_COUNTER,
    SET_MESSAGES_COUNTER,
    REQUEST_MESSAGES_RANGE,
    SET_MESSAGES_RANGE,
    // users
    REQUEST_USERS_COUNTER,
    SET_USERS_COUNTER,
    REQUEST_USERS_RANGE,
    SET_USERS_RANGE,
    // current_connections
    REQUEST_CONNECTIONS_COUNTER,
    REQUEST_CONNECTIONS_RANGE,
    SET_CONNECTIONS_COUNTER,
    SET_CONNECTIONS_RANGE
} from './constants'

//
// Messages
//

export function requestMessagesCounter() {
    return {
        type: REQUEST_MESSAGES_COUNTER,
        payload: {
            //dateRange
        }
    }
}
export function setMessagesCounter({ messagesCounter }) {
    return {
        type: SET_MESSAGES_COUNTER,
        payload: {
            messagesCounter
        }
    }
}
export function requestMessagesRange(params) {
    return {
        type: REQUEST_MESSAGES_RANGE,
        payload: {
            ...params
        }
    }
}
export function setMessagesRange({ messagesRange }) {
    return {
        type: SET_MESSAGES_RANGE,
        payload: {
            messagesRange
        }
    }
}

//
// Users
//

export function requestUsersCounter() {
    return {
        type: REQUEST_USERS_COUNTER,
        payload: {
            //dateRange
        }
    }
}
export function setUsersCounter({ usersCounter }) {
    return {
        type: SET_USERS_COUNTER,
        payload: {
            usersCounter
        }
    }
}
export function requestUsersRange(params) {
    return {
        type: REQUEST_USERS_RANGE,
        payload: {
            ...params
        }
    }
}
export function setUsersRange({ usersRange }) {
    return {
        type: SET_USERS_RANGE,
        payload: {
            usersRange
        }
    }
}

//
// Connections
//

export function requestConnectionsCounter() {
    return {
        type: REQUEST_CONNECTIONS_COUNTER,
        payload: {
            //dateRange
        }
    }
}
export function setConnectionsCounter({ connectionsCounter }) {
    return {
        type: SET_CONNECTIONS_COUNTER,
        payload: {
            connectionsCounter
        }
    }
}
export function requestConnectionsRange(params) {
    return {
        type: REQUEST_CONNECTIONS_RANGE,
        payload: {
            ...params
        }
    }
}
export function setConnectionsRange({ connectionsRange }) {
    return {
        type: SET_CONNECTIONS_RANGE,
        payload: {
            connectionsRange
        }
    }
}
